<template>
  <article
    class="article-item img-16by9 item-type-article match-tips-listing-article"
    v-if="article"
  >
    <div class="article-wrap">
      <div class="article-thumbnail">
        <a :href="matchUrl(article)" @click="onMatchClick($event, article)">
          <div class="img-box">
            <img
              v-if="lazyImgType"
              class="lazy"
              :src="defaultImg[lazyImgType]"
              :data-src="match_image(article, size)"
              :alt="article.match_name"
            />
            <img
              v-else
              :src="match_image(article, size)"
              :alt="article.match_name"
              importance="high"
            />
            <div v-if="!isFirstTile && article.series_name" class="series-wrapper">
              <div class="series-name">{{article.series_name}}</div>
            </div>
          </div>
          <span class="item-type-icon"></span>
        </a>
      </div>
      <div class="article-content">
        <a :href="matchUrl(article)" @click="onMatchClick($event, article)">
          <div v-if="isFirstTile && article.series_name" class="series-wrapper">
            <div class="series-name">{{article.series_name}}</div>
          </div>
          <p class="article-title">{{ generateHeadline() }}</p>
        </a>
        <div class="article-meta">
          <time class="meta meta-date" :data-date="article.match_start_date">{{
            getTimeSpan(article.match_start_date)
          }}</time>
        </div>
        <div class="article-description">
          <p>{{ article.event_name }}</p>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import {
  fetchMatchCodeFromString,
  daysBetween,
  addPagePropertiesToObject,
  sendTrackingData,
  getMatchInfoTitle,
  urlCorrections,
} from "../../assets/js/common";
import {
  CFG_WIDGET_URL_BASE,
  CFG_HEAD_TO_HEAD_IMAGE_FROM,
  CFG_TRACKING,
  CFG_MODULES,
} from "../../assets/js/config";
export default {
  props: [
    "article",
    "size",
    "isFirstTile",
    "listing_module",
    "headline_keys",
    "showDreamTeamImg",
    "showVideoImg",
    "lazyImgType"
  ],
  data() {
    return {
      defaultImg: {
        "square": "https://www.fantasygully.com/static-assets/images/cssimages/default-lazy-square.png",
        "rect": "https://www.fantasygully.com/static-assets/images/cssimages/default-lazy-rect.png"
      }
    }
  },
  computed: {
    translations() {
      return this.$store.state.translations;
    },
  },
  methods: {
    match_image(match, width) {
      let dimensions = this.isFirstTile ? "480,270" : "320,180";
      let mImgUrl = `${CFG_WIDGET_URL_BASE}/static-assets/images/16_9_Match-Tips.png?w=${width}`;
      if (match) {
        if (this.showVideoImg && match.fg_video_id) {
          mImgUrl = `https://www.fantasygully.com/ext-img/i.ytimg.com/vi/${match.fg_video_id}/maxresdefault.jpg?w=${width}`;
        } else if (this.showDreamTeamImg && match.dream_team_image_id) {
          mImgUrl = `${CFG_WIDGET_URL_BASE}/static-assets/images/article-images/${match.dream_team_image_id}?lb=${dimensions}&background=%2347ad22&crop=0px,250px,720px,400px`;
        } else {
          let show_htoh_image =
            new Date(CFG_HEAD_TO_HEAD_IMAGE_FROM) -
              new Date(match.match_start_date) <
            0;
          if (show_htoh_image) {
            let code = fetchMatchCodeFromString(match.url);
            let templateFolder = match.image_template_id
              ? match.image_template_id
              : "match-images";
            mImgUrl = `${CFG_WIDGET_URL_BASE}/static-assets/images/${templateFolder}/${code}.jpg?w=${width}`;
          }
        }
      }
      return mImgUrl;
    },
    getTimeSpan(time) {
      if (time) {
        const epochs = [
          ["year", 31536000],
          ["month", 2592000],
          ["day", 86400],
          ["hour", 3600],
          ["minute", 60],
          ["second", 1],
        ];

        const getDuration = (timeAgoInSeconds) => {
          if (timeAgoInSeconds < 0) {
            timeAgoInSeconds = Math.abs(timeAgoInSeconds);
          }
          for (let [name, seconds] of epochs) {
            const interval = Math.floor(timeAgoInSeconds / seconds);
            if (interval >= 1) {
              return {
                interval: interval,
                epoch: name,
              };
            }
          }
        };

        let timeSpan = daysBetween(new Date(), new Date(time));
        const timeAgoInSeconds = timeSpan.ms_Diff / 1000;
        const { interval, epoch } = getDuration(timeAgoInSeconds);
        const suffix = interval === 1 ? "" : "s";

        if (timeSpan.is_expired) {
          /* ago */
          return `${interval} ${epoch}${suffix} ago`;
        } else {
          /* to go */
          return `${interval} ${epoch}${suffix} to go`;
        }
      } else {
        return "";
      }
    },
    updateSlugPart(url, baseRoute) {
      if(baseRoute === CFG_MODULES.GAME_PLAN.route){
        return url.replace("dream11-prediction", "compare-fantasy-contests");
      } else if(baseRoute === CFG_MODULES.LINEUP.route){
        return url.replace("dream11-prediction", "team-generator");
      } else {
        return url;
      }
    },
    matchUrl(obj) {
      let hiUrl = this.$route && this.$route.path && this.$route.path.includes("/hi/") ? "/hi" : "";
      let videoRedirection = '';
      // if(this.showVideoImg && obj.fg_video_id){
      //   videoRedirection = '#video';
      // }
      if (this.listing_module) {
        let url = obj.url.replace(
          "match-tips-predictions/",
          `${this.listing_module.route}`
        );
        let urlPath = this.updateSlugPart(`${hiUrl}${url}`, this.listing_module.route);
        return urlCorrections(`${urlPath}${videoRedirection}`);
      } else {
        return urlCorrections(`${hiUrl}/${obj.url}${videoRedirection}`);
      }
    },
    onMatchClick(e, obj) {
      let toTrack = CFG_TRACKING["2"];
      toTrack.category = "click_to_match_tips_url";
      toTrack.value = this.matchUrl(obj);
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);
    },
    generateHeadline() {
      if (this.headline_keys) {
        let isHindi = this.$route && this.$route.path && this.$route.path.includes("/hi/");
        return getMatchInfoTitle(
          this.article,
          this.translations[this.headline_keys],
          false,
          isHindi
        );
      } else {
        return "";
      }
    },
  },
};
</script>